import type { Editor } from "@tiptap/vue-3";

export function isInsideAbsoluteTextBox(editor: Editor): boolean {
    const { $from } = editor.state.selection;

    for (let depth = $from.depth; depth > 0; depth--) {
        const node = $from.node(depth);
        if (node.type.name === "absoluteTextBox") {
            return true;
        }
    }

    return false;
}

export function insertContentAtCursor(editor: Editor, content: any) {
    editor.chain().focus().insertContent(content).run();
}
